import { LOCALE, SET_LOCALE, SET_TRANSLATIONS } from '../actions';
import { getLocale } from '../utils/intl';

const defaultState = {
  locale: getLocale(),
  translations: {},
};

export function i18n(state = defaultState, action = null) {
  switch (action.type) {
    case SET_LOCALE: {
      return Object.assign({}, state, { locale: action.locale });
    }

    case SET_TRANSLATIONS: {
      return Object.assign({}, state, { translations: action.translations });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/i18n.js